export const REGULAR_BUFFER_PERCENTAGE = 0.03;
export const DROPS_BELOW_LINE_BUFFER_PERCENTAGE = 0.5;
export const WRITING_TIMEOUT = 1000;
export const CANVAS_WIDTH = 200;
export const CANVAS_HEIGHT = 100;

export const SOUNDS_WRITING_RECOGNITION_MESSAGES = {
  CORRECT: (letter: string) => `Correctly written ${letter}`,
  INCORRECT: (letter: string) => `Incorrectly written ${letter}`,
  REVERSE: (letter: string) => `Reverse written ${letter}`,
  UNKNOWN: (letter: string) => `Unknown written ${letter}`,
  NOT_FOUND: '<no letter found for the current step>',
} as const;
